import { render, staticRenderFns } from "./PageNoPermission.vue?vue&type=template&id=da8da46c&scoped=true"
import script from "./PageNoPermission.vue?vue&type=script&lang=js"
export * from "./PageNoPermission.vue?vue&type=script&lang=js"
import style0 from "./PageNoPermission.vue?vue&type=style&index=0&id=da8da46c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da8da46c",
  null
  
)

export default component.exports